import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination, EffectCreative, EffectFade } from 'swiper/modules';

function image_carousel() {
    const imageCarousel = document.querySelector('.image-carousel-swiper');
    if (!imageCarousel) { return; }

    const img_blocks = document.querySelectorAll('[data-block="image-carousel"]');
    
    img_blocks.forEach(block => {
        // Find the swiper element
        const swiperEl = block.querySelector('.image-carousel-swiper');
        if (!swiperEl) return;
        
        // Get navigation elements
        const nextBtn = swiperEl.querySelector('.swiper-button-next');
        const prevBtn = swiperEl.querySelector('.swiper-button-prev');
        
        // Create swiper instance
        const swiper = new Swiper(swiperEl, {
            modules: [Navigation, Autoplay, EffectCreative],
            slidesPerView: 1,
            breakpoints: {
                768: {
                    slidesPerView: 3,
                },
            },
            centeredSlides: true,
			grabCursor: true,
            loop: true,
            loopAdditionalSlides: 1, // Add more slides for smoother looping
            speed: 600,
            preventInteractionOnTransition: true, // Prevent user interaction during transition
            navigation: {
                nextEl: nextBtn,
                prevEl: prevBtn,
            },
            on: {
                // Handle transition events to prevent multiple rapid clicks
                transitionStart: function() {
                    if (nextBtn) nextBtn.classList.add('pointer-events-none');
                    if (prevBtn) prevBtn.classList.add('pointer-events-none');
                },
                transitionEnd: function() {
                    if (nextBtn) nextBtn.classList.remove('pointer-events-none');
                    if (prevBtn) prevBtn.classList.remove('pointer-events-none');
                    
                    // Force re-calculation of active slides
                    this.update();
                }
            }
        });
        
        // Apply default transform origin on initialization
        
         
        // Prevent navigation clicks during transition
        let isTransitioning = false;
        
        
        
        swiper.on('slideChangeTransitionStart', function() {
            isTransitioning = true;
            nextBtn.classList.add('pointer-events-none');
            prevBtn.classList.add('pointer-events-none');
            
            // Set transform origin based on navigation direction
            
        });
        
        swiper.on('slideChangeTransitionEnd', function() {
            isTransitioning = false;
            nextBtn.classList.remove('pointer-events-none');
            prevBtn.classList.remove('pointer-events-none');
        });
    });
}

function simple_image_carousel() {
    console.log('Simple image carousel function called');
    const img_blocks = document.querySelectorAll('[data-block="simple_image_carousel"]');
    console.log('Found simple_image_carousel blocks:', img_blocks.length);
    
    if (!img_blocks.length) { return; }
    
    img_blocks.forEach((block, index) => {
        console.log(`Processing carousel block ${index + 1}`);
        const simple_image_carousel = block.querySelector('[data-target="simple_image_carousel"]');
        if (!simple_image_carousel) { 
            console.log('Could not find target element in block');
            return; 
        }
        console.log('Found carousel target element');
        
        const simple_image_carousel_pagination = simple_image_carousel.querySelector('.swiper-pagination')
        const simple_image_carousel_next_button = simple_image_carousel.querySelector('.swiper-button-next')
        const simple_image_carousel_prev_button = simple_image_carousel.querySelector('.swiper-button-prev')

        try {
            console.log('Initializing Swiper');
            const slider = new Swiper(simple_image_carousel, {
                modules: [Navigation, Pagination, Autoplay],
                loop: true,
                draggable: true,
                allowTouchMove: true,
                effect: 'slide',
                duration: 100,
                pagination: {
                    el: simple_image_carousel_pagination,
                    clickable: true,
                    type: "fraction",
                    renderFraction: (currentClass, totalClass) => {
                        return '<span class="' + currentClass + '"></span>' +
                                         ' of ' +
                                         '<span class="' + totalClass + '"></span>'
                        }
                },
                navigation: {
                    nextEl: simple_image_carousel_next_button,
                    prevEl: simple_image_carousel_prev_button,
                }
            });
            console.log('Swiper successfully initialized');
        } catch (error) {
            console.error('Error initializing Swiper:', error);
        }
    });
}

export { image_carousel, simple_image_carousel }; 